<template>
  <content-container :contentClass="'success'">
    <h1>Success!</h1>
    <p>Please wait in line for your name(s) to be called</p>
  </content-container>
</template>

<script>
import ContentContainer from "../../../components/content-container.vue";

export default {
  components: { ContentContainer },
  mounted: function () {
    console.log("EVENT")
    this.$parent.$emit("reachedFinished");
  },
};
</script>

<style lang="scss">
.success {
  text-align: center;
}
</style>